import { render, staticRenderFns } from "./EnvioDocumentosSolicitudCredenciales.vue?vue&type=template&id=4207da48"
import script from "./EnvioDocumentosSolicitudCredenciales.vue?vue&type=script&lang=js"
export * from "./EnvioDocumentosSolicitudCredenciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports